module.exports = __webpack_public_path__ + "static/media/26UNRWA4.33ff625a.jpg";